import { ApplicationRef, NgModule, Type } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import _get from "lodash/get";

import { AssistantsProfileSearchComponent } from "./entry-modules/assistants-profile-search/assistants-profile-search.component";
import { AssistantsProfileSearchModule } from "./entry-modules/assistants-profile-search/assistants-profile-search.module";
import { ContentSearchComponent } from "./entry-modules/content-search/content-search.component";
import { ContentSearchModule } from "./entry-modules/content-search/content-search.module";
import { EventSearchComponent } from "./entry-modules/event-search/event-search.component";
import { EventSearchModule } from "./entry-modules/event-search/event-search.module";
import { EventsManagementComponent } from "./entry-modules/events-management/events-management.component";
import { EventsManagementModule } from "./entry-modules/events-management/events-management.module";
import { EventsSearchComponent } from "./entry-modules/events-search/events-search.component";
import { EventsSearchModule } from "./entry-modules/events-search/events-search.module";
import { NewsSearchComponent } from "./entry-modules/news-search/news-search.component";
import { NewsSearchModule } from "./entry-modules/news-search/news-search.module";
import { TrainingsSearchComponent } from "./entry-modules/trainings-search/trainings-search.component";
import { TrainingsSearchModule } from "./entry-modules/trainings-search/trainings-search.module";
import { VacanciesSearchComponent } from "./entry-modules/vacancies-search/vacancies-search.component";
import { VacanciesSearchModule } from "./entry-modules/vacancies-search/vacancies-search.module";
import { VenuesSearchComponent } from "./entry-modules/venues-search/venues-search.component";
import { VenuesSearchModule } from "./entry-modules/venues-search/venues-search.module";

const entryComponents: Array<Type<any>> = [
    AssistantsProfileSearchComponent,
    ContentSearchComponent,
    EventSearchComponent,
    EventsManagementComponent,
    EventsSearchComponent,
    NewsSearchComponent,
    TrainingsSearchComponent,
    VacanciesSearchComponent,
    VenuesSearchComponent
];

@NgModule({
    imports: [
        BrowserModule,
        AssistantsProfileSearchModule,
        ContentSearchModule,
        EventSearchModule,
        EventsManagementModule,
        EventsSearchModule,
        NewsSearchModule,
        TrainingsSearchModule,
        VacanciesSearchModule,
        VenuesSearchModule
    ],
    entryComponents: entryComponents
})
export class AppModule {
    public ngDoBootstrap(applicationRef: ApplicationRef): void {
        entryComponents
            .map(component => ({
                component: component,
                nodes: [...document.querySelectorAll( _get(component, "SELECTOR"))] as Array<Node>
            }))
            .forEach(relation => {
                relation.nodes.forEach(node => {
                    applicationRef.bootstrap(relation.component, node);
                });
            });
    }
}
